import 'dayjs/locale/ar';
import 'dayjs/locale/de';
import 'dayjs/locale/et';
import 'dayjs/locale/es';
import 'dayjs/locale/ka';
import 'dayjs/locale/ru';
import 'dayjs/locale/uk';
import 'dayjs/locale/lt';
import { createI18n } from 'vue-i18n';
import dayjs from 'dayjs';
import en from '@/locales/en';
import ar from '@/locales/ar.json';
import de from '@/locales/de.json';
import et from '@/locales/ee.json';
import es from '@/locales/es.json';
import ka from '@/locales/ka.json';
import ru from '@/locales/ru.json';
import uk from '@/locales/uk.json';
import lt from '@/locales/li.json';

const locale: 'en' | string = process.env.VUE_APP_I18N_LOCALE || 'en';

const datetimeFormats = {
  date: { year: 'numeric', month: 'short', day: 'numeric' },
  short: {
    year: 'numeric',
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: 'numeric',
    hour12: false,
  },
} as const;

const i18n = createI18n({
  legacy: false,
  locale,
  fallbackLocale: process.env.VUE_APP_I18N_FALLBACK_LOCALE || 'en',
  messages: {
    en,
    ar,
    de,
    es,
    et,
    ru,
    uk,
    ka,
    lt,
  },
  datetimeFormats: {
    en: datetimeFormats,
    ar: datetimeFormats,
    de: datetimeFormats,
    es: datetimeFormats,
    et: datetimeFormats,
    ru: datetimeFormats,
    uk: datetimeFormats,
    ka: datetimeFormats,
    lt: datetimeFormats,
  },
});

dayjs.locale(locale);

export default i18n;
